/**
 * Agence'O - logo-slider
 * @author Guillaume Bouillon (Agence'O)
 * @created 14/05/2019
 */

(function ($) {

  if ($('.logo-slider__container').length) {
    const logoSlider = new Swiper('.logo-slider__container', {
      slidesPerView: 6,
      slidesPerGroup: 6,
      slidesPerColumn: 2,
      spaceBetween: 30,
      touchEventsTarget: 'wrapper',
      wrapperClass: 'logo-slider__wrapper',
      slideClass: 'logo-slider__item',
      slideActiveClass: 'is-active',
      slideNextClass: 'is-next',
      pagination: {
        el: '.logo-slider__pagination',
        type: 'bullets',
        clickable: true,
        bulletClass: 'logo-slider__pagination__bullet',
        bulletActiveClass: 'is-active'
      },
      navigation: {
        nextEl: '.logo-slider__btn--next',
        prevEl: '.logo-slider__btn--prev',
        disabledClass: 'is-disabled'
      },
      breakpoints: {
        991: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
        767: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
        575: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        }
      }
    });
  }

}(jQuery));
